"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multiplets = void 0;
const nmr_processing_1 = require("nmr-processing");
exports.Multiplets = nmr_processing_1.MultiplicityPatterns.map(({ label, value, acs, multiplicity }) => ({
    label: `${label}`,
    value: acs || value,
    multiplicity,
}));
